/* globals jQuery, Vue, Namespace, configurations */

import Vue from 'vue/dist/vue.js';

/**
 * This is a custom auto complete input component.
 * This javascript behaves in autocomplete_input.html.twig file with needs to be included with some params:
 */
(function ($, ns, cfg) {
    'use strict';

    var MIN_SEARCH_LENGTH = 2,
        AJAX_DONE = 4,
        COMPONENT = '[data-component="auto_complete_input"]',
        componentList = document.querySelectorAll(COMPONENT);

    /**
     * Check if components exists in current page before initialize
     */
    if (componentList.length > 0) {
        initializeComponent();
    }

    /**
     * Initialize N components
     */
    function initializeComponent() {
        var index, total;

        for (index = 0, total = componentList.length; index < total; index++) {
            setComponentFunctionality(componentList[index]);
        }
    }

    /**
     * Add functionality to a detected component
     * @param {Object|Node} element
     */
    function setComponentFunctionality(element) {
        var endpointPath = element.getAttribute('data-endpoint'),
            remote = element.getAttribute('data-remote'),
            fillLoc = element.getAttribute('data-fill-loc'),
            fillPop = element.getAttribute('data-fill-pop'),
            fillAe2 = element.getAttribute('data-fill-ae2'),
            // This value is set in storage.js
            initialValue = element.querySelector('input[type="text"]').value;

        /* eslint-disable no-new */
        new Vue({
            el: element,
            data: function () {
                return {
                    getPromise: null,
                    query: '',
                    results: [],
                    selectedOptionLabel: ''
                };
            },
            computed: {
                hasMinimumLength: function () {
                    return this.query.length > MIN_SEARCH_LENGTH;
                },
                behatRole: function () {
                    return 'company-name-input';
                },
                hasInputHidden: function () {
                    return typeof this.$refs.hasOwnProperty('ae2') && this.$refs.hasOwnProperty('popId');
                },
                autoCompleteAttr: function () {
                    return (Namespace.configurations.BROWSER.isChrome) ? 'new-password' : 'off';
                }
            },
            mounted: function () {
                var self = this;

                if (fillLoc) {
                    this.setStorageValues({
                        popName: fillLoc,
                        area2: fillAe2,
                        pop: fillPop
                    });
                }

                window.PubSub.subscribe(ns.TOPIC_NAMES.AUTO_COMPLETE_DATA, function (msg, data) {
                    self.setStorageValues(data);
                });
            },
            methods: {
                /**
                 * Check input value if auto fill dispatch event from storage
                 * @param {Object} data
                 */
                setStorageValues: function (data) {
                    this.query = this.selectedOptionLabel = data.popName;
                    this.setInputHiddenValues(data.area2, data.pop);
                },
                /**
                 * Check input value before vue instance auto filled by storage and set thi value
                 */
                checkInitialValue: function () {
                    if (initialValue.length > 0) {
                        this.query = this.selectedOptionLabel = initialValue;
                    }
                    if (this.query === '') {
                        this.$refs.auto_complete.value = '';
                    }
                },
                /**
                 * On click input, check if it has some value and evaluate query
                 */
                checkDefaultQuery: function () {
                    if (this.hasMinimumLength) {
                        this.evaluateQuery();
                    }
                },
                /**
                 * Evaluate input query if is grater than minimum required length
                 */
                evaluateQuery: function () {
                    var self = this;
                    if (this.hasMinimumLength) {
                        this.abortPreviousRequest();
                        this.getPromise = this.getQueryResults();

                        this.getPromise.then(function (response) {
                            self.results = self.mapResults(response);
                        });
                    } else {
                        this.clearResults();
                    }
                },
                /**
                 * Get query results from backend
                 * @return {Promise}
                 */
                getQueryResults: function () {
                    var DEFAULT_URL = endpointPath + '?q=' + this.query + '&country=';
                    if (remote) {
                        DEFAULT_URL += document.getElementById(remote).value;
                    } else {
                        DEFAULT_URL += cfg.project.projectCountryId;
                    }

                    return $.get(DEFAULT_URL);
                },
                /**
                 * Abort previous requests if exist and is not complete
                 */
                abortPreviousRequest: function () {
                    if (this.getPromise !== null && this.getPromise.readyState !== AJAX_DONE) {
                        this.getPromise.abort();
                    }
                },
                /**
                 * Map results before render autocomplete
                 * @param {Object|String} response
                 * @return {Array}
                 */
                mapResults: function (response) {
                    var result;

                    if (typeof response === 'string') {
                        result = JSON.parse(response);
                    } else {
                        result = response;
                    }

                    return result.data;
                },
                /**
                 * Select option click event callback
                 * @param {Object} selectedOption
                 */
                selectOption: function (selectedOption) {
                    this.query = this.selectedOptionLabel = selectedOption.label;
                    this.setInputHiddenValues(selectedOption.ae2_id, selectedOption.pop_id);
                    this.clearResults();
                },
                /**
                 * Set population and area2 values to input hidden
                 * @param {String} area2
                 * @param {String} pop
                 */
                setInputHiddenValues: function (area2, pop) {
                    if (this.hasInputHidden) {
                        this.$refs.ae2.value = area2;
                        this.$refs.popId.value = pop;
                    }
                },
                /**
                 * Clear results
                 */
                clearResults: function () {
                    this.results = [];
                },
                /**
                 * Reset auto complete results
                 */
                resetAutoComplete: function () {
                    if (this.selectedOptionLabel.length === 0) {
                        this.clearField();
                    }
                    this.clearResults();
                },
                /**
                 * Clear field
                 */
                clearField: function () {
                    this.query = '';
                    this.selectedOptionLabel = '';
                    if (this.hasInputHidden) {
                        this.$refs.ae2.value = '';
                        this.$refs.popId.value = '';
                    }
                },
                checkOptionSelected: function () {
                    if (this.query !== this.selectedOptionLabel) {
                        this.clearField();
                    }
                }
            },
            watch: {
                /**
                 * Synchronize v-model with input value
                 * @param {String} newValue
                 */
                query: function (newValue) {
                    this.$refs.auto_complete.value = newValue;
                }
            },
            directives: {
                /**
                 * Evaluate document click target in order to detect outside clicks
                 */
                clickOutside: {
                    bind: function (el, binding, vnode) {
                        el.event = function (event) {
                            if (!(el === event.target ||
                                    el.contains(event.target) ||
                                    event.target.classList.contains('c-auto-complete-item') ||
                                    event.target.classList.contains('c-auto-complete-list'))) {
                                vnode.context[binding.expression](event);
                            }
                        };
                        document.body.addEventListener('click', el.event);
                    },
                    unbind: function (el) {
                        document.body.removeEventListener('click', el.event);
                    }
                }
            }
        });
    }

    ns.module = ns.module || {};
    ns.module.autoComplete = initPopulationAutoComplete;

    /**
     * Initialize population autocomplete.
     *
     * @param {jQuery} $form
     */
    function initPopulationAutoComplete($form) {
        var $autoCompleteComponent = $form.find('[data-component="auto_complete_input"]');

        $autoCompleteComponent.each(function (index, field) {
            setComponentFunctionality(field);
        });
    }

}(jQuery, Namespace, configurations));
